export default __webpack_public_path__ + "static/media/star-full-blue.f62f41c5.svg";